import DOMPurify from 'dompurify';
import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import {
  getSessionStorageItem,
  removeSessionStorageItem,
} from '../../utils/sessionStorage';
import ReviewingLastQuizNotice from '../Common/CommonDailysQuiz/ReviewingLastQuizNotice/ReviewingLastQuizNotice';
import { Desktop, Mobile } from '../Common/const';
import HelpButton from '../Common/HelpButton/HelpButton';
import ProgressBar from '../Common/ProgressBar';
import FurtherReading from '../Question/FurtherReading';
import QuestionCard from '../Question/QuestionCard';
import SwitchToPaidModal from '../SwitchToPaid/SwitchToPaidModal.jsx';
import Timer from './Timer.jsx';

class Daily20QuizReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      update: false,
      questions: JSON.parse(getSessionStorageItem('quiz'))
        ? JSON.parse(getSessionStorageItem('quiz')).questions
        : this.props.quiz
          ? this.props.quiz.questions
          : history.push('/app/daily-quiz'),
      currentQuestion: 0,
      timer: 1800,
      isOpenSwitchToPaid: false,
    };
  }

  componentDidMount() {
    if (
      this.props?.quiz?.questions &&
      Array.isArray(this.props?.quiz?.questions) &&
      this.props?.quiz?.questions.length > 0
    ) {
      this.props.setQuestion(this.props.quiz.questions[0]);
    }
  }

  openPdfViewer = () => {
    this.props.openPdfViewer(true);
  };

  UNSAFE_componentWillMount() {
    if (getSessionStorageItem('quiz')) {
      this.props.setDailyQuiz(JSON.parse(getSessionStorageItem('quiz')));
    } else {
      removeSessionStorageItem('quiz');
    }
  }

  componentWillUnmount() {
    removeSessionStorageItem('quiz');

    const isReviewingLastDailyQuiz = JSON.parse(
      getSessionStorageItem('isReviewingLastDailyQuiz'),
    );
    const isReviewingLastQualDailyQuiz = JSON.parse(
      getSessionStorageItem('isReviewingLastQualDailyQuiz'),
    );

    if (isReviewingLastDailyQuiz) {
      removeSessionStorageItem('isReviewingLastDailyQuiz');
    }

    if (isReviewingLastQualDailyQuiz) {
      removeSessionStorageItem('isReviewingLastQualDailyQuiz');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Open reference or chapter pdf when link is received from API
    if (prevProps.pdfLink !== this.props.pdfLink && !this.props.showPdfViewer) {
      window.open(this.props.pdfLink.url);
    }
    if (
      (!this.props.question || Object.keys(this.props.question).length === 0) &&
      Array.isArray(this.props?.quiz?.questions) &&
      this.props?.quiz?.questions.length > 0
    ) {
      this.props.setQuestion(this.props.quiz.questions[0]);
    }
  }

  getClickedState = () => {
    const clicked = this.state.questions[this.state.currentQuestion].clicked;
    if (clicked === true) {
      return true;
    }
    return false;
  };

  updateIsCorrect = (Correct) => {
    this.setState({
      isCorrect: Correct,
    });
  };

  setClicked = () => {
    const questions = [...this.state.questions];
    const question = {
      ...questions[this.state.currentQuestion],
      clicked: true,
    };
    questions[this.state.currentQuestion] = question;

    this.setState({
      questions,
    });
  };

  submitAnswer = () => {
    const isReviewingLastDailyQuiz = JSON.parse(
      getSessionStorageItem('isReviewingLastDailyQuiz'),
    );
    const isReviewingLastQualDailyQuiz = JSON.parse(
      getSessionStorageItem('isReviewingLastQualDailyQuiz'),
    );

    const nextQuestion = this.state.currentQuestion + 1;
    const questionCount = this.state.questions.length;

    const isReviewingLastQuiz =
      isReviewingLastDailyQuiz || isReviewingLastQualDailyQuiz;

    if (questionCount === nextQuestion && !isReviewingLastQuiz) {
      history.push('/app/daily20quizResults');
    } else if (questionCount === nextQuestion && isReviewingLastQuiz) {
      history.push('/app/daily-quiz');
    } else {
      this.props.setQuestion(this.props.quiz.questions[nextQuestion]);
      this.setState({
        currentQuestion: nextQuestion,
      });
    }
  };

  previousQuestion = () => {
    const previousQuestion = this.state.currentQuestion - 1;
    this.props.setQuestion(this.props.quiz.questions[previousQuestion]);
    this.setState({
      currentQuestion: previousQuestion,
    });
  };

  getAnswerId = (questionId) => {
    let resultsDetailed = this.props.quiz.resultsDetailed;

    if (!this.props.quiz.reviewHistoryMode) {
      resultsDetailed = JSON.parse(resultsDetailed);
    }
    const specificResult = resultsDetailed.find(
      (result) => result.id_question === questionId,
    );
    return specificResult ? specificResult.id_answer : null;
  };

  exitQuiz = () => {
    history.push('/app/daily-quiz');
    // this.props.setDailyQuiz(null);
  };

  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text;
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }
    return result;
  };

  renderPreviousNextButton = (
    buttonLabel,
    previousQuestionDisabled,
    previousQuestionClass,
  ) => (
    <div className="col-12 col-sm-12 col-md-5 mt-4 text-right p-0 previous-next-container text-center text-md-right">
      <Button
        color="secondary"
        disabled={previousQuestionDisabled}
        className={`${previousQuestionClass} col-8 col-sm-5 col-md-12 col-lg-10 col-xl-5 offset-lg-2 offset-xl-0 mb-1 mb-sm-0 mb-md-1 mb-xl-0 mx-0`}
        onClick={this.previousQuestion}
      >
        <i className="icon-chevron_left" /> Previous Question
      </Button>

      <Button
        color="secondary"
        className="col-8 col-sm-5 col-md-12 col-lg-10 col-xl-5 offset-lg-2 offset-xl-0 mt-1 mt-sm-0 mt-md-1 mt-xl-0 ml-0 ml-sm-1 mx-md-0 ml-xl-1"
        onClick={this.submitAnswer}
      >
        {buttonLabel} <i className="icon-chevron_right" />
      </Button>
    </div>
  );

  openSwitchToPaid = () => {
    this.setState({ isOpenSwitchToPaid: true });
  };

  closeSwitchToPaid = () => {
    this.setState({ isOpenSwitchToPaid: false });
  };

  render() {
    if (
      !this.props?.quiz?.questions ||
      !Array.isArray(this.props?.quiz?.questions) ||
      this.props?.quiz?.questions?.length === 0
    ) {
      return <div className="question-main-body dailyquizreview" />;
    }
    const question = this.props.quiz.questions[this.state.currentQuestion];
    const nextQuestion = this.state.currentQuestion + 1;
    const questionCount = this.state.questions.length;
    let buttonLabel = 'Next Question';
    let previousQuestionDisabled = false;
    let previousQuestionClass = 'secondary';

    // this is the reference for further reading
    let page = [];
    const pages = this.props.quiz.questions.map((a) => {
      if (question.id === a.id) {
        if (a.documentPage != undefined) {
          page = a.documentPage;
        }
      }
    });
    let pageForTitle = '';
    if (page) {
      pageForTitle = ` - PAGE ${page}`;
    }
    const reference =
      question.reference_name + question.reference_description + pageForTitle;

    const isReviewingLastDailyQuiz = JSON.parse(
      getSessionStorageItem('isReviewingLastDailyQuiz'),
    );

    if (questionCount === nextQuestion && !isReviewingLastDailyQuiz) {
      buttonLabel = 'Show results';
    }

    if (questionCount === nextQuestion && isReviewingLastDailyQuiz) {
      buttonLabel = 'EXIT QUIZ';
    }

    if (nextQuestion === 1) {
      previousQuestionDisabled = true;
      previousQuestionClass = 'btn-outline-secondary disabled';
    }
    const userSubscription = this.props.userSubscription;
    const isTrial = userSubscription && userSubscription.status === 'trialing';
    const isCancelled = userSubscription && userSubscription.isCancelled;
    const hasNoStatus = userSubscription && !userSubscription.status;

    return (
      <div className="question-main-body dailyquizreview">
        <div className="question-background">
          <div className="question-wrapper daily20quiz">
            <Desktop>
              <div className="d-flex flex-row justify-content-between">
                <h2>Daily 20 Quiz</h2>
                {isReviewingLastDailyQuiz ? (
                  <ReviewingLastQuizNotice className="review__textbox" />
                ) : null}
              </div>
              <div className="row">
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <h3>
                    <b>Q:</b>{' '}
                    <span
                      className="questions-p"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          this.renderSymbols(question.text),
                        ),
                      }}
                    />
                  </h3>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 pt-3 text-right">
                  <Timer
                    time={this.state.timer}
                    review
                    exitQuiz={this.exitQuiz}
                  />
                </div>
              </div>
            </Desktop>
            <Mobile>
              <div className="row">
                {isReviewingLastDailyQuiz ? (
                  <ReviewingLastQuizNotice className="review__textbox ml-auto mr-auto mt-3" />
                ) : null}
                <div className="col-12 pt-3 text-center">
                  <Timer
                    time={this.state.timer}
                    review
                    exitQuiz={this.exitQuiz}
                  />
                </div>
                <div className="col-12">
                  <h3>
                    <b>Q:</b>{' '}
                    <span
                      className="questions-p"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          this.renderSymbols(question.text),
                        ),
                      }}
                    />
                  </h3>
                </div>
              </div>
            </Mobile>
          </div>
        </div>
        <div className="question-wrapper mt-dynamic">
          <QuestionCard
            {...question}
            clicked={this.getClickedState}
            setClicked={this.setClicked}
            getClickedState={this.getClickedState}
            updateIsCorrect={this.updateIsCorrect}
            answerId={this.getAnswerId(question.id)}
            fromReview
          />
          <Desktop>
            <div className="d-flex button-row mt-2">
              <div className="col-12 col-md-7 col-sm-12 pl-0 ">
                <ProgressBar
                  total={this.props.quiz.questions.length}
                  progress={this.state.currentQuestion + 1}
                  review={1}
                  title
                />
              </div>
              {this.renderPreviousNextButton(
                buttonLabel,
                previousQuestionDisabled,
                previousQuestionClass,
              )}
            </div>
            <div className="row button-row mt-3 mx-0">
              <div className="feedback d-inline-block ml-auto float-right">
                <HelpButton title="Report Question" question={question} />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-8">
                <FurtherReading
                  disabled={isTrial || (isCancelled && hasNoStatus)}
                  onDisabledClick={this.openSwitchToPaid}
                  reference={reference}
                  notes={question.notes}
                  openPdfViewer={this.openPdfViewer}
                  pdfUrl={
                    question.reference_pdf
                      ? question.reference_pdf
                      : question.chapter_pdf
                        ? question.chapter_pdf
                        : ''
                  }
                  getPdfByReference={(url, chapter) =>
                    this.props.getPdfByReference({
                      url,
                      chapterId: chapter,
                    })
                  }
                />
              </div>
            </div>
          </Desktop>
          <Mobile>
            <div className="p-2">
              <ProgressBar
                total={this.props.quiz.questions.length}
                progress={this.state.currentQuestion + 1}
                review={1}
                title
              />
            </div>
            {this.renderPreviousNextButton(
              buttonLabel,
              previousQuestionDisabled,
              previousQuestionClass,
            )}
            <div className="row button-row mt-3 mx-0">
              <div className="feedback d-inline-block ml-auto float-right">
                <HelpButton title="Report Question" question={question} />
              </div>
            </div>
          </Mobile>
        </div>
        <div>
          <SwitchToPaidModal
            isOpen={this.state.isOpenSwitchToPaid}
            onCancel={this.closeSwitchToPaid}
            activateSubscription={() => this.props.activateSubscription()}
            subscriptionActivationSucces={
              this.props.subscriptionActivationSucces
            }
            subscriptionActivationWaiting={
              this.props.subscriptionActivationWaiting
            }
            subscriptionActivationMessage={
              this.props.subscriptionActivationMessage
            }
          />
        </div>
      </div>
    );
  }
}

export default Daily20QuizReview;
